(()=>{
  function onScroll(){
    if (window.scrollY > 0) {
      document.body.classList.add('scroll');
    } else {
      document.body.classList.remove('scroll');
    }
  }

  // 제품 상세페이지(body) 클래스 토글
  function applyProductBodyClass(){
    const isProduct =
      location.pathname.startsWith('/products/') ||    // URL 기반
      !!document.querySelector('product-info');        // Dawn/OS2 DOM 기반(보험)

    document.body.classList.toggle('is-product', isProduct);
  }

  function markExternalLinks(root=document){
    const host = location.host;

    root.querySelectorAll('a[href]').forEach(a=>{
      const href = a.getAttribute('href');

      // 스킵: 앵커/전화/메일/JS
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

      // 스킵: 이미 target 지정된 것(의도 존중)
      if (a.hasAttribute('target')) return;

      // 절대 URL 판별 (상대경로도 처리)
      let url;
      try {
        url = new URL(href, location.origin);
      } catch(e){
        return;
      }

      // 외부 도메인만 새창 처리
      if (url.host && url.host !== host) {
        a.setAttribute('target','_blank');
        a.setAttribute('rel','noopener noreferrer');
      }
    });
  }

  function init(){
    onScroll();

    // PDP body 클래스 1회 적용
    applyProductBodyClass();

    // 1) 최초 1회
    markExternalLinks(document);

    // 2) 헤더/드로어가 동적으로 바뀌는 경우 대응
    const mo = new MutationObserver((mutations)=>{
      for (const m of mutations){
        for (const node of m.addedNodes){
          if (node.nodeType === 1) {
            // 새로 추가된 DOM 조각만 스캔
            markExternalLinks(node);

            // ✅ OS2 리렌더/동적 로딩 시에도 PDP 클래스 재확인(가벼움)
            // 필요 최소한으로만 호출되도록 addedNodes에서만 실행
            applyProductBodyClass();
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList:true, subtree:true });
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('scroll', onScroll, { passive:true });
})();
